import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../../config';
import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';

export type Accounts = {
    id: string;
    accounts: Account[];
};

export type Account = {
    id: string;
    name: string;
    active: boolean;
};

// Define a service using a base URL and expected endpoints
export const accountsApi = createApi({
    reducerPath: 'accountsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.USER_MANAGEMENT_SERVICE,
        prepareHeaders,
    }),
    endpoints: builder => ({
        fetchAccounts: builder.query<Accounts, { userId: string }>({
            query: ({ userId }) => ({
                url: `/users/${userId}/accounts`,
                responseHandler: async (response: Response) => {
                    const data = await response.json();
                    return data;
                },
            }),
        }),
    }),
});

// Export hooks for usage in function components which are
// auto-generated based on defined endpoints
export const { useFetchAccountsQuery } = accountsApi;
